<template>
  <div class="register">
    <div class="page-title">
      Register
    </div>
    <v-alert type="error" v-if="alert"> {{ alertText }} </v-alert>
    <div class="px-5">
      <v-row class="mb-2">
        <v-text-field
          @keypres.enter="login"
          type="email"
          v-model="email"
          label="Email"
        />
      </v-row>

      <v-row class="m-between">
        <v-text-field
          type="password"
          v-model="password"
          label="Password"
          @keypres.enter="login"
        />
      </v-row>

      <v-row>
        <v-btn class="mt-n8" color="indigo" :loading="loading" dark @click="register">Register</v-btn>
      </v-row>
  </div>
  </div>
</template>

<script>
import firebase from "firebase";
import db from "../../firebase";

export default {
  name: "register",
  data: function() {
    return {
      email: "",
      password: "",
      alert: false,
      alertText: "",
      loading: false
    };
  },
  methods: {
    register: function(e) {
      this.loading = true

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(user => {
          let uid = user.user.uid
          
            db.collection("categories")
            .add({
              name: "Today",
              authorID: uid
            })
            this.$router.go({ path: this.$router.path });
          },
          error => {
            this.alert = true
            this.alertText = error.message
            this.loading = false
          }
        );

      e.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../public/_app.scss";
</style>
